import {
	Component, EventEmitter, Input, Output, OnChanges, SimpleChanges, SimpleChange,
	ViewChildren, ViewChild, AfterViewInit, ElementRef, QueryList, ChangeDetectionStrategy,
	ChangeDetectorRef, OnInit, OnDestroy
} from '@angular/core';
import { Observable, Subject, Subscription } from 'rxjs/Rx';
import { DiscResultsService } from 'discovery';
import { IdentityService } from 'identity';
import { NavigationService } from 'netview';
import { MessageService } from 'base';
import {
	InfoSetView, InfoSetViewColumn, InfoSetViewEntry, InfoSetViewValue
} from 'UvExplorerServer.Dtos.TS/Session';
import { ReportViewerComponent } from '../report-viewer/report-viewer.component';


@Component({
	selector: 'reports',
	templateUrl: './reports.component.html',
	styleUrls: ['./reports.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsComponent implements OnInit, OnChanges, OnDestroy {

	public AssetInventoryReport = "asset-inventory-report";
	public DeviceConnectivityReport = "device-connectivity-report";
	public SoftwareReport = "software-report";
	public ProcessesReport = "processes-report";
	public ComputerSystemsReport = "computer-systems-report";
	public BiosReport = "bios-report";
	public OperatingSystemsReport = "operating-systems-report";
	public ProcessorsReport = "processors-report";
	public DiskDrivesReport = "disk-drives-report";
	public LogicalDisksReport = "logical-disks-report";
	public StalePortReport = "stale-port-report";
	public IpPhoneReport = "ip-phone-report";
	public PortDetailReport = "port-detail-report";
	public ScannedPortsReport = "scanned-ports-report";

	private networkLoadedSub: Subscription;

	public selectedReport: string;
	public selectedReportInfo: InfoSetView;

	@ViewChild(ReportViewerComponent)
	public reportViewer: ReportViewerComponent;

	constructor(private discResultsService: DiscResultsService,
		private identityService: IdentityService,
		private navService: NavigationService,
		private messageService: MessageService,
		private changeDetector: ChangeDetectorRef) {

		this.selectedReport = "";
		this.selectedReportInfo = this.emptyInfoSetView();

		this.networkLoadedSub = this.discResultsService.onNetworkLoaded.subscribe(
			() => {
				this.selectedReport = "";
				this.selectReport(this.AssetInventoryReport);
			},
			(error?) => {
				// ???
			});
	}

	public ngOnInit(): void {

	}

	public ngOnChanges(changes: SimpleChanges): void {
		
	}

	public ngOnDestroy(): void {
		if (this.networkLoadedSub) {
			this.networkLoadedSub.unsubscribe();
			this.networkLoadedSub = null;
		}
	}

	public reloadReport(): void {
		if (this.reportViewer) {
			this.reportViewer.reloadReport();
		}
	}

	public selectReport(reportName: string): void {
		let sessionGuid = this.identityService.sessionGuid;
		let netViewGuid = this.navService.location.netViewGuid;
		let agentGuid = this.navService.location.agentGuid;
		let schedDiscGuid = this.navService.location.schedDiscGuid;
		let schedDiscRsltGuid = this.navService.location.schedDiscRsltGuid;

		if (!!sessionGuid && !!netViewGuid && !!reportName) {
			this.discResultsService.getReportView(sessionGuid, netViewGuid, agentGuid,
				schedDiscGuid, schedDiscRsltGuid, reportName).subscribe(
				(result: InfoSetView) => {
					this.selectedReport = reportName;
					this.selectedReportInfo = result;
					this.changeDetector.markForCheck();
				},
				(error?) => {
					this.messageService.displayErrorMessage("Could not retrieve the selected report");
				});
		}
	}

	private emptyInfoSetView(): InfoSetView {
		return {
			infoSetName: "",
			title: "",
			columns: [],
			entries: []
		};
	}

	public updateScannedPortsReport(entries: any[]): void {
		if (entries) {
			entries.forEach((entry) => {
				if (entry.portStatus) {
					if (!entry.styles) {
						entry.styles = {};
					}
					entry.styles.portStatus = ((entry.portStatus.toLowerCase() == "open") ? "port-status-open" : "port-status-closed");
				}
			});
		}
	}

}
